import { Routes } from "@angular/router";
import {
  LoginFailedComponent,
  LogoutComponent,
  PageNotFoundComponent,
  RegisterStep1Component,
  RegisterStep2Component,
  RegisterStep3Component
} from "@core/containers";
import { environment } from "@environments/environment";

export const routes: Routes = [
  {
    path: "organizations",
    loadChildren: () => import("./organizations/routes").then((m) => m.routes),
    canActivate: [...environment.authGuards]
  },
  {
    path: "my-account",
    loadChildren: () => import("./my-account/routes").then((m) => m.routes),
    canActivate: [...environment.authGuards]
  },
  {
    path: "users",
    loadChildren: () => import("./users/routes").then((m) => m.routes),
    canActivate: [...environment.authGuards]
  },
  {
    path: "register-step-1",
    component: RegisterStep1Component
  },
  {
    path: "register-step-2",
    component: RegisterStep2Component
  },
  {
    path: "register-step-3",
    component: RegisterStep3Component,
    canActivate: [...environment.authGuards]
  },
  {
    path: "logout",
    component: LogoutComponent
  },
  {
    path: "login-failed",
    component: LoginFailedComponent
  },
  {
    path: "",
    redirectTo: "my-account",
    pathMatch: "full"
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];
